<form [formGroup]="form" class="rulesForm">
  <div formArrayName="fields" class="full-width">
    @for (field of fieldLines; track field; let j = $index; let isFirst = $first; let isLast = $last) {
      <div [formGroupName]="j"
        class="padding-vertical-4 margin-vertical-4 rulesGroup">
        <ng-container>
          <mat-form-field class="margin-horizontal-4" subscriptSizing="dynamic">
            <mat-label>Name (on TD dashboard)</mat-label>
            <input type="text" matInput formControlName="name" />
            @if (field.get('name').hasError('nameValidator')) {
              <mat-error>
                can't contain spaces or special symbols
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field class="margin-horizontal-4" subscriptSizing="dynamic">
            <mat-label>{{field.get('validationType').value === 'hidden' ? 'Field Value' : 'Field Label'}}</mat-label>
            <input type="text" matInput formControlName="label" />
          </mat-form-field>
          <mat-form-field class="margin-horizontal-4">
            <mat-label translate>Field Type</mat-label>
            <mat-select formControlName="validationType" class="padding-horizontal-4">
              <mat-option value="text" translate> Text</mat-option>
              <mat-option value="email" translate> Email</mat-option>
              <mat-option value="name" translate> Name</mat-option>
              <mat-option value="checkbox" translate> Checkbox</mat-option>
              <mat-option value="phone" translate> Phone No.</mat-option>
              <mat-option value="privacy-policy" translate> Privacy Policy</mat-option>
              <mat-option value="hidden" translate> Hidden</mat-option>
            </mat-select>
          </mat-form-field>
          @if (integrationId && maFields) {
            <mat-form-field class="margin-horizontal-4">
              <mat-label translate>Field Name in {{maDisplayName}}</mat-label>
              <mat-select formControlName="maName" class="padding-horizontal-4">
                @for (maField of maFields; track maField.name) {
                  <mat-option [value]="maField.name" translate> {{maField.label}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          <mat-checkbox class="margin-horizontal-4" formControlName="required" class="padding-horizontal-4">Required
          </mat-checkbox>
        </ng-container>
        <div class="action-icons">
          @if (j>0) {
            <mat-icon matTooltip="{{'Delete' | translate}}" (click)="removeFieldLine(j)"
              class="margin-horizontal-4">
            remove</mat-icon>
          }
          @if (j===fieldLines.length-1) {
            <mat-icon matTooltip="{{'Add' | translate}}" (click)="addFieldLine()"
              class="margin-horizontal-4">
            add_circle</mat-icon>
          }
          <div class="ordering-buttons">
            @if (fieldLines.length>1 && !isFirst) {
              <mat-icon class="ordering-icon" (click)="move(j, j-1)">arrow_upward
              </mat-icon>
            }
            @if (fieldLines.length>1 && !isLast) {
              <mat-icon class="ordering-icon" (click)="move(j, j+1)">arrow_downward
              </mat-icon>
            }
          </div>
        </div>
      </div>
    }
  </div>
</form>
